// extracted by mini-css-extract-plugin
module.exports = {"ims_wrapper":"myIms_ims_wrapper__2XbXw","ims_wrapper_mb":"myIms_ims_wrapper_mb__38Y6w","col_div":"myIms_col_div__KWG7e"};